import React,{useState} from 'react';
import PropTypes from 'prop-types';

import Checkbox from '../../atoms/checkBox/Checkbox';
import { PromotionStyle } from './PlanNameStyle';

const PlanTypeItem = (props) => {
    let [check, setCheck] = useState(false);
    const handlePlanNameCheck = (event) => {
        let flag=event.target.checked;
        setCheck(flag)
        props.plannameClickHandler(flag)
    }
    const checkFilteredPlanName = () => {
        return props.filteredPlanName.filter(brand => brand.value === props.planname.value).length > 0 ? true : false
    }

    return (
        <ul className='list'>
            <li>
                <Checkbox
                isChecked={
                    props?.filteredPlanName?.length > 0 ? checkFilteredPlanName() :
                    props?.filteredPlanName?.length === 0 ? false : check
                }
                id={`${props.planname.label}`}
                check={`${props.planname.label} `}
                click={handlePlanNameCheck}
                />
            </li>
            <style jsx>{PromotionStyle}</style>
        </ul>
    );
};

PlanTypeItem.propTypes = {
    promotion: PropTypes.object,
    filteredPromotions: PropTypes.array,
    promoClickHandler: PropTypes.func,
    plannameClickHandler: PropTypes.func,
    filteredPlanName: PropTypes.array,
    planname: PropTypes.object
};

export default PlanTypeItem;

